import type { Disposable } from '@/shared/types/core'

/** 引擎帧调度模式。 */
export type FrameDriverMode = 'continuous' | 'on-demand'

/** FrameDriver 的可观察生命周期；idle 仅用于已启动的 on-demand driver。 */
export type FrameDriverState = 'stopped' | 'running' | 'idle' | 'disposed'

/** FrameDriver 只传递浏览器调度源给出的时间戳。 */
export type FrameDriverCallback = (timestamp: DOMHighResTimeStamp) => void

/**
 * 唯一帧回调 owner。
 *
 * Driver 不接收 invalidation reason/ViewId，也不执行 resize、render 或 GPU submit。
 */
export interface FrameDriver extends Disposable {
  readonly mode: FrameDriverMode
  readonly state: FrameDriverState
  readonly scheduled: boolean

  start(callback: FrameDriverCallback): void
  stop(): void
  invalidate(): void
}

/** Driver 调度 API 或 tick callback 的受控错误出口。 */
export type FrameDriverErrorHandler = (error: Error, phase: string) => void

export function normalizeFrameDriverError(error: unknown): Error {
  return error instanceof Error ? error : new Error(String(error))
}
